import PropTypes from 'prop-types';

import { BrandPropTypes } from '@/common/proptypes/Common/Brand/Brand.proptypes';
import { FlagsPropTypes } from '@/common/proptypes/Common/Flags/Flags.proptypes';
import { ImagePropTypes } from '@/common/proptypes/Common/Image/Image.proptypes';

export const OrderItemDefaultProps = {
  comment: null,
  id: null,
  loyalty_point: null,
  is_selected: false,
  label: null,
  price: null,
  product: {},
  product_id: null,
  public_price: null,
  quantity: null,
  remaining_quantity: null,
  sale_unit: null,
  shipping_tracking_number: null,
  supplier_reference: null,
  total: null,
  total_line_amount: null,
  weee_tax_amount: null,
  weee_total_product_amount: null,
};

export const OrderItemPropTypes = {
  comment: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  is_selected: PropTypes.bool,
  label: PropTypes.string,
  loyalty_point: PropTypes.number,
  price: PropTypes.number,
  product: {
    ...BrandPropTypes,
    ...FlagsPropTypes,
    ...ImagePropTypes,
    name: PropTypes.string,
    path: PropTypes.string,
    sku: PropTypes.string,
    slug: PropTypes.string,
  },
  product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  public_price: PropTypes.number,
  quantity: PropTypes.number,
  remaining_quantity: PropTypes.number,
  sale_unit: PropTypes.string,
  shipping_tracking_number: PropTypes.number,
  supplier_reference: PropTypes.string,
  total: PropTypes.number,
  total_line_amount: PropTypes.number,
  weee_tax_amount: PropTypes.number,
  weee_total_product_amount: PropTypes.number,
};
